import { render, staticRenderFns } from "./ArrowMenu.vue?vue&type=template&id=964a974c&scoped=true&"
import script from "./ArrowMenu.vue?vue&type=script&lang=js&"
export * from "./ArrowMenu.vue?vue&type=script&lang=js&"
import style0 from "./ArrowMenu.vue?vue&type=style&index=0&id=964a974c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a974c",
  null
  
)

export default component.exports